<template>
  <base-dialog
    v-model="localValue"
    :show-cancel="true"
    :show-confirm="false"
    cancel-label="Close"
    :hide-close-button="true"
    confirm-button-class="base-dialog__primary-btn"
    @confirm="$emit('close')"
    persistent
  >
    <div class="business-contact-dialog__content text-center">
      <q-icon name="check_circle" size="48px" color="positive" class="q-mb-md" />
      <h4 class="business-contact-dialog__title">Thank you for your interest</h4>
      <p class="business-contact-dialog__text">Our team will be happy to discuss custom solutions for your organization.</p>
      <p class="business-contact-dialog__text">
        You can also contact us at <a href="mailto:tech@flashy.ai?subject=Enterprise%20Plan%20Inquiry" class="business-contact-dialog__link">tech@flashy.ai</a>.
      </p>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue';

export default {
  name: 'BusinessContactDialog',
  components: {
    BaseDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.business-contact-dialog {
  &__content {
    padding: 8px 0;
  }

  &__title {
    @include mona-sans-font($size: 24px, $bolded: true, $color: var(--main-text-color));
    margin: 0 0 16px 0;
  }

  &__text {
    @include inter-font($size: 16px, $color: var(--main-text-color));
    margin: 0;
    max-width: 350px;
    margin: 0 auto;
  }

  &__link {
    @include inter-font($size: 16px, $bolded: false, $color: var(--main-text-color));
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
